import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { nth } from '../../../../utils';
import { pipe, groupBy, toPairs, map, prop, filter } from 'ramda';
import { TeamCell } from '../../'; 

const SimpleTimetable = (props) => {
  const data = pipe(
    // HIDE PLAYOFF ROUNDS for users!
    filter(match => props.editable ? true :  match.matchType === 'QUALIFICATION'),
    groupBy(prop('beginTime')),
    toPairs,
    map(t => ({ beginTime: t[0], teams: t[1] }))
  )( props.data || []);

  let columns = [
    nth,
    { Header: 'Begin', accessor: 'beginTime', maxWidth: 60 },
    { Header: 'End', accessor: 'teams[0].endTime', maxWidth: 50 },
    { Header: 'Group', accessor: 'teams[0].group', maxWidth: 50 },
    { Header: 'Attempt', accessor: 'teams[0].attempt', maxWidth: 70 }
  ];

  for (let i = 0; i < props.columns; i += 1) {
    let num = i + 1;

    columns.push( {
      Header: 'Participant #' + num,
      id: 't' + num,
      maxWidth: 300,
      Cell: ({ original: { teams: t }}) => {
        let val = t[i] ? t[i].robotNumber : '';

        if (val && t[i].result !== null) {
          if (t[i].resultUnit === 'MILLISECONDS') {
            val += ' (' + parseInt(t[i].result, 10)/1000  + ' sec)';
          } else {
            val += ' (' + t[i].result  + ')';
          }     
        }

        return val;
      }
    });
  }
  
  return (
    <ReactTable
      className='-striped -highlight'
      data={data}
      columns={columns}
      defaultSorted={[
        { id: 'beginTime', desc: false }
      ]}
      SubComponent={({ original: o }) =>
                    <TeamCell data={o} editable={props.editable}/>}
      pageSize={data.length}
      showPagination={false}
    />
  );
};

export default SimpleTimetable;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tables/SimpleTimetable/index.js